import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cx from 'classnames/bind'
import { StarOutlined } from '@material-ui/icons'
import {referralGenerateCode} from '../../../actions'

const ReferralContent = (props = {}) => {
  const [email, setEmail] = useState('')
  const [userStatus, setUserStatus] = useState(null)
  const [referralCode, setReferralCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [copied, setCopied] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!email) return

    setIsLoading(true)
    setUserStatus('checking')
    setError(null)

    try {
      const response = await props.actions.referralGenerateCode(email)

      if (response.success) {
        setReferralCode(response.data.referralCode)
        setUserStatus('VIP')
      } else {
        const code = response.code

        if (code === 'NOT_COMMUNITY_USER') {
          setUserStatus(code)
        }

        if (code === 'NOT_VIP_USER') {
          setUserStatus(code)
        }
      }
    } catch (error) {
      setError({
        type: "api",
        message: "Unable to check your status. Please try again.",
        retryable: true,
      })
      setUserStatus(null)
    } finally {
      setIsLoading(false)
    }
  }

  const handleRetry = () => {
    setError(null)
    if (email) {
      handleSubmit({ preventDefault: () => {} })
    }
  }

  const dismissError = () => {
    setError(null)
  }

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(referralCode)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      setError({
        type: "api",
        message: "Unable to check your status. Please try again.",
        retryable: true,
      })
    }
  }

  const handleDownloadApp = () => {
    window.open(
      'https://links.theasianparent.com/C8OGmS',
      '_blank'
    )
  }

  const handleRegisterVip = () => {
    window.open('https://www.parents.vip/influencer/profile/edit', '_blank')
  }

  const resetForm = () => {
    setEmail("")
    setUserStatus(null)
    setReferralCode("")
    setCopied(false)
    setError(null)
  }

  return (
    <div className={cx('main-card')}>
      <div className={cx('card-content')}>
        {!userStatus && (
          <form onSubmit={handleSubmit} className={cx('email-form')}>
            <div className={cx('form-group')}>
              <label htmlFor="email" className={cx('form-label')}>
                Email Address
              </label>
              <div className={cx('input-wrapper')}>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className={cx('email-input')}
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={isLoading || !email}
              className={cx('submit-button')}
            >
              {isLoading ? 'Checking...' : 'Check My Status'}
            </button>
          </form>
        )}

        {userStatus === 'checking' && (
          <div className="checking-status">
            <div className="loading-spinner"></div>
            <p className="checking-text">Checking your VIP status...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <div className="error-card">
              <div className="error-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
              <h3 className="error-title">Oops! Something went wrong</h3>
              <p className="error-message">{error.message}</p>
              <div className="error-actions">
                {error.retryable && (
                  <button onClick={handleRetry} className="retry-button">
                    <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      />
                    </svg>
                    Try Again
                  </button>
                )}
                <button onClick={dismissError} className="dismiss-button">
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        )}

        {userStatus === 'NOT_COMMUNITY_USER' && (
          <div className="status-result">
            <div className="status-card not-community">
              <svg
                className="status-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <h3 className="status-title">Join Our Community First!</h3>
              <p className="status-description">
                Download theAsianparent app to become part of our amazing
                community.
              </p>
              <button
                onClick={handleDownloadApp}
                className="action-button download-button"
              >
                <svg
                  className="button-icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                Download App
              </button>
            </div>
            <button onClick={resetForm} className="reset-button">
              Try Different Email
            </button>
          </div>
        )}

        {userStatus === 'NOT_VIP_USER' && (
          <div className="status-result">
            <div className="status-card community-not-vip">
              <svg
                className="status-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
              <h3 className="status-title">Upgrade to VIP!</h3>
              <p className="status-description">
                You're part of our community! Join as VIP to access exclusive
                referral rewards.
              </p>
              <button
                onClick={handleRegisterVip}
                className="action-button vip-button"
              >
                <StarOutlined className={cx('button-icon')} />
                Become VIP Member
              </button>
            </div>
            <button onClick={resetForm} className="reset-button">
              Try Different Email
            </button>
          </div>
        )}

        {userStatus === 'VIP' && (
          <div className="status-result">
            <div className="status-card vip-success">
              <div className="success-icon-wrapper">
                <StarOutlined className={cx('success-icon')} />
              </div>
              <h3 className="status-title">Welcome VIP Member! 🎉</h3>
              <p className="status-description">
                Here's your exclusive referral code. Share it with friends and
                earn amazing rewards!
              </p>

              <div className="referral-code-container">
                <p className="code-label">Your Referral Code</p>
                <div className="code-display">
                  <span className="referral-code">{referralCode}</span>
                  <button onClick={handleCopyCode} className="copy-button">
                    <svg
                      className="copy-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  </button>
                </div>
                {copied && (
                  <p className="copied-message">✓ Copied to clipboard!</p>
                )}
              </div>
            </div>
            <button onClick={resetForm} className="reset-button">
              Check Another Email
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

//map state
const mapStateToProps = (state, ownProps) => ({ rdx: state })

//map dispatch
const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: bindActionCreators({
    referralGenerateCode
  }, dispatch)
})
export default connect(mapStateToProps, mapDispatchToProps)(ReferralContent)
